export enum DocumentActionEnum {
  REJECT = 'REJECT', CANCEL = 'CANCEL', REINSTATE = 'REINSTATE', SUSPEND = 'SUSPEND', CONTINUE = 'CONTINUE', SIGN = 'SIGN', VISA = 'VISA', NEXT='NEXT'
}
